<div fxLayout="column" fxLayoutGap="10px" style="padding-bottom: 5px;font-family: Roboto, Helvetica Neue, sans-serif;">
  <mat-form-field>
    <mat-select placeholder="Filtrer sur un type de sort final..."
                [formControl]="conservationControl"
                [matTooltip]="'Filtrer sur un type de sort final...'"
                (selectionChange)="onSelected($event)">
      <ng-container>
        <mat-option *ngFor="let conservation of conservations" [value]="conservation">
          <div [innerHTML]="depositSvc.displayConservationByType(conservation)" [attr.data-cy]="'option-filter-conservation-deposits-' + conservation.id"></div>
        </mat-option>
      </ng-container>
    </mat-select>
  </mat-form-field>
  <div>
    <button color="accent" class="mat-button mat-small" mat-raised-button (click)="onValidate($event)" matTooltip="Filtrer" data-cy="btn-conservation-deposit-filtering">Filtrer</button>&nbsp;
  </div>
</div>
